export default __webpack_public_path__ + "f854efee6cba9953768e30f87b398f71.png";